import { QuoteStatusesType } from "../../../common/const/quote/quoteStatuses.const";
import Typography from "@/components/Typography/Typography";
import { noBidReasonOptions } from "@/common/const/filter-options";

interface VendorQuoteLineStatusInfoProps {
  status: QuoteStatusesType;
  noBidReason: string | null;
}
export default function VendorQuoteLineStatusInfo({
  status,
  noBidReason,
}: VendorQuoteLineStatusInfoProps) {
  if (status === "Expired") {
    return (
      <Typography
        type="p"
        customStyles="font-kanit text-base font-semibold text-error"
      >
        Quote Expired
      </Typography>
    );
  }
  if (status === "Loss") {
    return (
      <Typography
        type="p"
        customStyles="font-kanit text-base font-semibold text-error"
      >
        Quote Lost
      </Typography>
    );
  }
  if (status === "NoBid") {
    return (
      <p className="font-kanit text-base font-medium text-gray-dim">
        Quote declined by reason:{" "}
        {noBidReasonOptions.find((el) => el.value === noBidReason)?.label}
      </p>
    );
  }
  if (status === "Pending") {
    return null;
  }
  if (status === "Quoted") {
    return (
      <Typography
        type="p"
        customStyles="font-kanit text-base font-semibold text-yellow-secondary"
      >
        Quote on Customer review
      </Typography>
    );
  }
  if (status === "Won") {
    return (
      <Typography
        type="p"
        customStyles="font-kanit text-base font-semibold text-success-dark"
      >
        Order placed
      </Typography>
    );
  }
  return null;
}
